// GINZA VAULT — Minimal Interactive Logic
// No e-commerce. Announcement ticker, FAQ accordion, inquiry form → CF Function.

document.addEventListener('DOMContentLoaded', () => {
  initTicker();
  initFAQ();
  initInquiryForm();
  initNewsletterForm();
});

// ── Announcement Ticker ──
function initTicker() {
  const slides = document.querySelectorAll('.ticker-slide');
  if (!slides.length) return;
  let i = 0;

  setInterval(() => {
    slides[i].classList.remove('active');
    i = (i + 1) % slides.length;
    slides[i].classList.add('active');
  }, 4500);
}

// ── FAQ Accordion ──
function initFAQ() {
  document.querySelectorAll('.faq-trigger').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.faq-item');
      const body = item.querySelector('.faq-body');
      const isOpen = item.classList.contains('open');

      // close all
      document.querySelectorAll('.faq-item').forEach(el => {
        el.classList.remove('open');
        el.querySelector('.faq-body').style.maxHeight = null;
      });

      if (!isOpen) {
        item.classList.add('open');
        body.style.maxHeight = body.scrollHeight + 'px';
      }
    });
  });
}

// ── Inquiry Form → Cloudflare Function ──
function initInquiryForm() {
  const form = document.getElementById('inquiry-form');
  if (!form) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    const btn = form.querySelector('.form-submit');
    const original = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '<i class="fa-solid fa-spinner fa-spin"></i> Submitting...';

    const payload = Object.fromEntries(new FormData(form));

    try {
      let res;
      try {
        res = await fetch('/api/sourcing', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
      } catch {
        // Fallback for local dev without CF worker
        res = {
          ok: true,
          json: async () => ({
            success: true,
            referenceId: 'GV-' + Math.floor(10000 + Math.random() * 90000)
          })
        };
      }

      const data = await res.json();

      if (data.success || res.ok) {
        const refId = data.referenceId || 'GV-' + Date.now();
        showToast('Inquiry submitted successfully. Reference: ' + refId);
        form.reset();
      } else {
        showToast('Submission failed. Please try again.');
      }
    } catch (err) {
      console.error(err);
      showToast('Network error. Please try again.');
    } finally {
      btn.disabled = false;
      btn.innerHTML = original;
    }
  });
}

// ── Newsletter Form → Cloudflare Function (reuses /api/sourcing) ──
function initNewsletterForm() {
  const form = document.getElementById('newsletter-form');
  if (!form) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    const input = form.querySelector('.newsletter-input');
    const btn = form.querySelector('.newsletter-btn');
    const email = input.value.trim();
    if (!email) return;

    const original = btn.textContent;
    btn.disabled = true;
    btn.textContent = '...';

    const payload = {
      contactEmail: email,
      category: 'Newsletter Subscription',
      itemName: 'Newsletter Subscription',
      notes: 'Opt-in via footer newsletter form.'
    };

    try {
      let res;
      try {
        res = await fetch('/api/sourcing', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
      } catch {
        // Fallback for local dev without CF worker
        res = { ok: true, json: async () => ({ success: true }) };
      }

      const data = await res.json();

      if (data.success || res.ok) {
        showToast('Subscribed! You\'ll hear about Tokyo previews first.');
        form.reset();
      } else {
        showToast('Subscription failed. Please try again.');
      }
    } catch (err) {
      console.error(err);
      showToast('Network error. Please try again.');
    } finally {
      btn.disabled = false;
      btn.textContent = original;
    }
  });
}

// ── Toast ──
function showToast(message) {
  let wrap = document.querySelector('.toast-wrap');
  if (!wrap) {
    wrap = document.createElement('div');
    wrap.className = 'toast-wrap';
    document.body.appendChild(wrap);
  }

  const t = document.createElement('div');
  t.className = 'toast';
  t.innerHTML = '<i class="fa-solid fa-circle-check" style="color:var(--gold)"></i> ' + message;
  wrap.appendChild(t);

  setTimeout(() => {
    t.style.opacity = '0';
    t.style.transform = 'translateX(100%)';
    t.style.transition = 'all 0.4s ease';
    setTimeout(() => t.remove(), 400);
  }, 4000);
}
